<template>
    <div class="absolute h-full w-full flex items-center justify-center z-60 text-primary"
         style="backdrop-filter: blur(3px)">
        <font-awesome-icon icon="circle-notch" spin style="font-size: 3rem;"/>
    </div>
</template>

<script>
    export default {
        name: "ChartLoadingOverlay"
    }
</script>

<style scoped>

</style>